import * as React from "react";
import PropTypes from "prop-types";

import DialogFormWithMutation from "dialogs/DialogFormWithMutation";
import { FormGroupTitle, FormTextField, FormDateField } from "ui/Form";

import useSettingsTlsSuggests from "hooks/suggests/useSettingsTlsSuggests";

import {
  UPDATE_LICENSE_CERTIFICATE,
  READ_TLS_SETTINGS_NAME,
} from "graphqlQueries/system";
import { updateLicenseCertificateValidator } from "validators/updateLicenseCertificateValidator";
import { licenseTimeShowFormat } from "utils/parseTime";

const fieldsWithPlaceForError = ["hostname", "expiration_date"];

const UpdateLicenseCertificate = (props) => {
  const { loading, update_license_cert_files } = useSettingsTlsSuggests();
  const initialValues = {
    hostname: "",
    expiration_date: "",
    ...update_license_cert_files,
  };
  const dateFormatter = (date) => date.format("YYYYMMDD235959") + "Z";

  return (
    <DialogFormWithMutation
      mutationQueries={UPDATE_LICENSE_CERTIFICATE}
      refetchQueries={[READ_TLS_SETTINGS_NAME]}
      initialValues={initialValues}
      validationSchema={updateLicenseCertificateValidator}
      fieldsWithPlaceForError={fieldsWithPlaceForError}
      title="Update license certificate"
      submitButtonName="Save"
      className="dialog-default-width"
      preLoading={loading}
      preLoadingHeight="180px"
      enableReinitialize
      {...props}
    >
      <FormGroupTitle title="Certificate information" />
      <FormTextField name="hostname" label="Hostname" />
      <FormDateField
        name="expiration_date"
        label="Expiration date"
        error={dateFormatter}
        exitDateFormat={dateFormatter}
        entryDateFormat={licenseTimeShowFormat}
        format={licenseTimeShowFormat}
      />
    </DialogFormWithMutation>
  );
};

UpdateLicenseCertificate.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default UpdateLicenseCertificate;
